const initFormTabList = () => {
    const formTabListWidgetList = document.querySelectorAll("[data-form-tab-list-widget]");
    if (formTabListWidgetList && formTabListWidgetList.length > 0) {
        formTabListWidgetList.forEach((formTabListWidget) => {
            const togglerTabList = document.querySelectorAll("[data-toggler-tab]");
            const toggledFormList = formTabListWidget.querySelectorAll("[data-to-be-toggled-form]");
            togglerTabList.forEach((togglerTab) => {
                togglerTab.addEventListener("click", () => {
                    const togglerTabAttribute = togglerTab.getAttribute("data-toggler-tab");
                    for (let j = 0; j < togglerTabList.length; j++) {
                        togglerTabList[j].classList.remove("active");
                    }
                    for (let i = 0; i < toggledFormList.length; i++) {
                        const toggledFormAttribute = toggledFormList[i].getAttribute("data-to-be-toggled-form");
                        if (togglerTabAttribute == toggledFormAttribute) {
                            toggledFormList[i].classList.add("active");
                            if (!toggledFormList[i].querySelector("[data-position-list]")) {
                                toggledFormList[i].querySelector("[data-work-with-us-form]").classList.add("active");
                            }
                            else {
                                toggledFormList[i].querySelector("[data-work-with-us-form]").classList.remove("active");
                            }
                        }
                        else {
                            toggledFormList[i].classList.remove("active");
                        }
                    }
                    // Set the active class on the corresponding tab selector
                    const tabSelectors = formTabListWidget.querySelectorAll(".tab-selector");
                    for (let k = 0; k < tabSelectors.length; k++) {
                        const formItemId = tabSelectors[k].getAttribute("data-toggler-tab");
                        if (formItemId === togglerTabAttribute) {
                            tabSelectors[k].classList.add("active");
                        }
                        else {
                            tabSelectors[k].classList.remove("active");
                        }
                    }
                });
            });
            const formContainers = document.querySelectorAll("[data-form-container]");
            if (formContainers && formContainers.length > 0) {
                formContainers.forEach((formContainer) => {
                    const jobPositionCtaList = formContainer.querySelectorAll("[data-job-position-cta]");
                    const jobPositionInput = formContainer.querySelector("[data-job-position-input]");
                    const workWithUsForm = formContainer.querySelector("[data-work-with-us-form]");
                    if (jobPositionCtaList && jobPositionCtaList.length > 0) {
                        jobPositionCtaList.forEach((jobPositionCta) => {
                            jobPositionCta.addEventListener("click", (e) => {
                                e.preventDefault();
                                workWithUsForm.classList.add("active");
                                jobPositionInput.value = jobPositionCta.getAttribute("data-job-position-cta");
                                workWithUsForm.scrollIntoView();
                            });
                        });
                    }
                });
            }
            initEducationCheckbox(formTabListWidget);
            initMoreWorkExperience(formTabListWidget);
            initAttachedFile(formTabListWidget);
        });
    }
};
// #region initEducationCheckbox
const initEducationCheckbox = (formTabListWidget) => {
    const educationList = formTabListWidget.querySelectorAll("[data-education]");
    educationList.forEach(education => {
        const educationCheckbox = education.querySelector("[data-education-checkbox]");
        const boxContent = education.querySelector("[data-show-content-education]");
        educationCheckbox.addEventListener("change", () => {
            setTimeout(() => {
                if (educationCheckbox.checked == true) {
                    boxContent.classList.add("active");
                }
                else {
                    boxContent.classList.remove("active");
                }
            }, 0);
        });
    });
};
// #endregion
// #region initMoreWorkExperience
const initMoreWorkExperience = (formTabListWidget) => {
    const workExperienceList = formTabListWidget.querySelectorAll("[data-work-experience]");
    if (workExperienceList && workExperienceList.length > 0) {
        workExperienceList.forEach((workExperience) => {
            const addMoreButton = workExperience.querySelector("[data-add-experience-btn]");
            const workExperienceContainer = workExperience.querySelector("[data-work-experience-container]");
            const boxInputFormExperienceCounter = workExperienceContainer.querySelector("[data-count-box-experience]");
            let boxInputFormArray = workExperienceContainer.querySelectorAll("[data-box-input-experience]");
            let deleteButtonsArray = workExperienceContainer.querySelectorAll("[data-delete-btn]");
            let counterBox;
            // #region First Work Experience Delete Button
            const deleteButton = workExperience.querySelector("[data-delete-btn]");
            deleteButton.addEventListener("click", () => {
                deleteExperience(deleteButton, deleteButtonsArray, counterBox, boxInputFormArray, boxInputFormExperienceCounter);
            });
            // #endregion
            // CLICK BUTTON ADD MORE
            addMoreButton.addEventListener("click", () => {
                counterBox = parseInt(boxInputFormExperienceCounter.getAttribute("data-count-box-experience"));
                //#region ADD +1 TO THE VALUE OF THE HIDDEN INPUT 
                counterBox = counterBox + 1;
                boxInputFormExperienceCounter.setAttribute("data-count-box-experience", `${counterBox}`);
                boxInputFormExperienceCounter.setAttribute("value", `${counterBox}`);
                boxInputFormArray.forEach((boxInputForm) => {
                    const deleteButton = boxInputForm.querySelector("[data-delete-btn]");
                    if (counterBox >= 2) {
                        deleteButton.setAttribute("data-show", "show");
                        boxInputForm.setAttribute("data-box-input-experience", "more");
                    }
                });
                //#endregion
                // #region TAKE LAST INPUT BOX
                const cloneBox = boxInputFormArray[boxInputFormArray.length - 1].cloneNode(true);
                const boxLabelArray = cloneBox.querySelectorAll("label");
                const boxInputArray = cloneBox.querySelectorAll("input");
                const boxTextAreaArray = cloneBox.querySelectorAll("textarea");
                const deleteButtonClone = cloneBox.querySelector("[data-delete-btn]");
                let forText;
                let substringForText;
                let numberForText;
                // #region CHANGE FOR, NAME, ID
                boxLabelArray.forEach((boxLabel) => {
                    if (boxLabel.hasAttribute("for")) {
                        forText = boxLabel.getAttribute("for");
                        substringForText = forText.substring(forText.indexOf("-") + 1);
                        numberForText = parseInt(substringForText);
                        forText = forText.replace(substringForText, `${numberForText + 1}`);
                        boxLabel.setAttribute("for", forText);
                    }
                });
                boxInputArray.forEach((boxInput) => {
                    if (boxInput.hasAttribute("name")) {
                        forText = boxInput.getAttribute("name");
                        substringForText = forText.substring(forText.indexOf("-") + 1);
                        numberForText = parseInt(substringForText);
                        numberForText += 1;
                        forText = forText.replace(substringForText, (`${numberForText}`));
                        boxInput.setAttribute("name", forText);
                        boxInput.setAttribute("id", forText);
                        boxInput.value = "";
                    }
                });
                boxTextAreaArray.forEach((boxTextArea) => {
                    if (boxTextArea.hasAttribute("name")) {
                        forText = boxTextArea.getAttribute("name");
                        substringForText = forText.substring(forText.indexOf("-") + 1);
                        numberForText = parseInt(substringForText);
                        numberForText += 1;
                        forText = forText.replace(substringForText, (`${numberForText}`));
                        boxTextArea.setAttribute("name", forText);
                        boxTextArea.setAttribute("id", forText);
                        boxTextArea.value = "";
                    }
                });
                // #endregion
                // #region DELETE BUTTON
                deleteButtonsArray = workExperienceContainer.querySelectorAll("[data-delete-btn]");
                workExperienceContainer.append(cloneBox);
                deleteButtonClone.addEventListener("click", () => {
                    deleteExperience(deleteButtonClone, deleteButtonsArray, counterBox, boxInputFormArray, boxInputFormExperienceCounter);
                });
                // #endregion
                boxInputFormArray = workExperienceContainer.querySelectorAll("[data-box-input-experience]");
                // #endregion
            });
        });
    }
};
// #endregion
// #region deleteExperience
const deleteExperience = (deleteButton, deleteButtonsArray, counterBox, boxInputFormArray, boxInputFormExperienceCounter) => {
    counterBox = parseInt(boxInputFormExperienceCounter.getAttribute("data-count-box-experience"));
    counterBox = counterBox - 1;
    if (counterBox <= 1) {
        for (let i = 0; i < deleteButtonsArray.length; i++) {
            deleteButtonsArray[i].setAttribute("data-show", "");
        }
        for (let j = 0; j < deleteButtonsArray.length; j++) {
            boxInputFormArray[j].setAttribute("data-box-input-experience", "");
        }
    }
    boxInputFormExperienceCounter.setAttribute("data-count-box-experience", counterBox.toString());
    boxInputFormExperienceCounter.setAttribute("value", counterBox.toString());
    deleteButton.parentElement.remove();
};
// #endregion
// #region initAttachedFile
const initAttachedFile = (formTabListWidget) => {
    const cvList = formTabListWidget.querySelectorAll("[data-cv]");
    cvList.forEach((cv) => {
        const attachedFileInput = cv.querySelector("[data-attached-file]");
        const labelCV = cv.querySelector("[data-text-cv]");
        attachedFileInput.addEventListener("change", () => {
            //Name of file and placeholder
            const file = attachedFileInput.files[0].name;
            labelCV.innerHTML = file;
        });
    });
};
// #endregion
